import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { envVarService } from './services/base/envVarService'

const selectedApp = await envVarService.getEnvVar('REACT_APP_APP_SELECTION') || 'base';
const AppToRender = React.lazy(() => import(`./apps/${selectedApp}/App`));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <AuthProvider>
      <AppToRender />
    </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
